import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createIcon } from '@chakra-ui/icons';
export const EllipseEmptyIcon = ({ fillColor }) => createIcon({
    displayName: 'EllipseEmptyIcon',
    viewBox: '0 0 8 8',
    path: (_jsx(_Fragment, { children: _jsx("circle", { cx: "4", cy: "4", r: "3.5", stroke: fillColor, fill: "transparent" }) })),
});
//# sourceMappingURL=EllipseEmptyIcon.js.map